module.exports = {
	"hello": "Bonjour",
	"Material": "Matériel",
	"Größe": "Dimension",
	"Themenwelten": "Catégories",
	"Bitte wählen Sie eine Lieferadresse aus:": "Choisir une adresse de livraison",
	"min_order_value": "Valeur minimum de commande",
	"min_order_value_ok": "Valeur minimum de commande atteint",
	"availability": {
		"soon": "bientôt disponible",
		"available": "disponible"
	},
	"delivery": "Livraison",
	"product": {
		"availability": "disponibilité",
		"deliverable": "disponible",
		"articlenr": "numéro d'article",
		"popularity": "popularité",
		"price": "prix",
		"single_price": "prix à l'unité",
		"label": "étiquette",
		"sum": "total",
		"amount": "total articles",
		"piece": "pièce"
	},
	"address": {
		"address": "adresse",
		"salutation": "salutation",
		"company": "entreprise",
		"surname": "nom de famille",
		"street": "rue",
		"invoice": "adresse de facturation",
		"addition": "en plus",
		"pcode": "code postale",
		"country": "pays",
		"city": "ville",
		"first_name": "nom",
		"delivery_address": "adresse de livraison"
	},
	"products": {
		"search": "recherche (numéro d'article, code-barres, nom)"
	},
	"orderlist": {
		"add": "ajouter, sauvegarder",
		"on_orderlist": "sur la liste",
		"added": "ajouté, sauvegardé",
		"all_lists": "toutes les listes"
	},
	"csv": {
		"uploadFile": "télécharger fiche"
	},
	"category": {
		"from_this_category": "dans cette catégorie",
		"last_viewed": "dernièrement consulté"
	},
	"shop": {
		"login": "se connecter",
		"register": "enregistrer",
		"user": "utilisateur",
		"password": "mot de passe",
		"lost_password": "mot de passe oublié",
		"VE": "colisage",
		"create": "créer",
		"finalize_order": "terminer la commande",
		"please_login_for_product_details": "Merci de se connecter pour voir tous les détails.",
		"continue_shopping": "continuer l'achat",
		"check_and_confirm": "vérifer et confirmer",
		"navigate_to_checkout": "naviguer pour check out",
		"sort": "sort",
		"deliverable": "disponible",
		"article": "articles",
		"articles_per_site": "articles par page",
		"to_top": "haute de page",
		"add_all_products": "ajouter tous les produits",
		"add": "ajouter",
		"select": "selectionner",
		"close": "fermer",
		"open": "ouvrir",
		"selected": "selectionné",
		"delete": "supprimer",
		"list": "liste",
		"back": "retourner",
		"comment": "commentaire",
		"add_new_address": "ajouter nouvelle adresse",
		"AGB_DELIVERY_INFO": "CGV et conditions de livraison ",
		"CONFIRM_AGB_DELIVERY_INFO": "confirmer CGV et conditions de livraison",
		"continue": "continuer"
	},
	"cart": {
		"your_comment": "votre commentaire",
		"cart": "panier",
		"positions": "positions",
		"piece": "pièce",
		"subtotal": "sous total",
		"address": "adresse",
		"check_and_submit": "vérifer et confirmer"
	},
	"nav": {
		"account": "compte",
		"logout": "déconnecter",
		"quickorder": "achat express",
		"service": "service",
		"privacy": "privé",
		"menu": "menu",
		"orderlist": "liste de commandes"
	},
	"message": {
		"min_order_value": "vous n'avez pas encore atteint le valeur minimum de commande",
		"empty_cart": "vous n'avez aucun produit dans votre panier."
	},
	"misc": {
		"price_a_piece": "prix à l'unité"
	},
	"footer": {
		"delivery": "livraison",
		"imprint": "emprinte",
		"contact": "contact",
		"request_catalogue": "demander catalogue",
		"new_client": "nouveau client enregistrement",
		"change_address": "changer adresse",
		"AGB": "CGV"
	},
	"reset": {
		"reset": "mot de passe oublié",
		"your_mail": "votre adresse e-mail",
		"back": "retourner",
		"choose_password": "choisir nouveau mot de passe",
		"your_new_password": "votre nouveau mot de passe",
		"repeat_password": "repeter mot de passe",
		"set_password": "choisir mot de passe",
		"too_short": "votre mot de passe est trop court",
		"too_short_explained": "choissisez un mot de passe plus longue",
		"passwords_not_equal": "mots de passe ne sont pas concordants",
		"passwords_not_equal_explained": "vous n'avez pas entré le meme mot de passe",
		"success": "votre mot de passe est accepté",
		"success_explained": "nous avons envoyé des intructions pour réinitialiser votre mot de passe à votre adresse email",
		"success_explained_long": "Merci de suivre les instructions recu. Si vous ne pouvez pas recevoir d'email le service en ligne vous aiderait.",
		"mail_not_found": "e-mail n'est pas enregistré",
		"mail_not_found_explained": "nous n'avons pas trouvé de compte avec votre adresse email"
	},
	"strings": {
		"new_account_hint": "vous avez besoin d'une compte",
		"new_account_action": "enregistrer",
		"new_account_enabled": "nouveau compte activé vous avez déjá commandé ici"
	},
	"error": {
		"login_error": "données invalides"
	},
	"brand_not_avail": "Malheureusement cette marque n'est pas disponible dans votre pays."
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr.json
// module id = 835
// module chunks = 0